import { useState } from "react";
import { StickyNote, Lock, BellRing, Trash2, Plus } from "lucide-react";
import { toast } from "sonner";
import { updateCliente, addAppunto, delAppunto } from "./clubApi";
import { Btn, Card, inputCls } from "./ui";

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
const today = () => new Date().toLocaleDateString("sv-SE");

export default function PrivateNotes({ cliente, onSaved }) {
  const [v, setV] = useState("");
  const [ric, setRic] = useState(cliente.richiamo || "");
  const [busy, setBusy] = useState(false);
  const appunti = [...(cliente.appunti || [])].reverse();
  const scaduto = !!cliente.richiamo && cliente.richiamo <= today();
  const ricDirty = ric !== (cliente.richiamo || "");

  const add = async () => {
    if (!v.trim()) return;
    setBusy(true);
    try { await addAppunto(cliente.id, v); setV(""); toast.success("Appunto aggiunto"); onSaved(); } catch { toast.error("Errore nel salvataggio"); }
    setBusy(false);
  };
  const remove = async (a) => {
    if (!window.confirm("Eliminare questo appunto?")) return;
    try { await delAppunto(cliente.id, a.id); onSaved(); } catch { toast.error("Errore"); }
  };
  const saveRic = async () => {
    setBusy(true);
    try { await updateCliente(cliente.id, { richiamo: ric }); toast.success(ric ? "Segnato. Quel giorno te lo ricordiamo nell'email delle 9." : "Richiamo tolto"); onSaved(); } catch { toast.error("Errore nel salvataggio"); }
    setBusy(false);
  };

  return (
    <Card className="mt-5 space-y-3" data-testid="private-notes">
      <div className="flex items-center justify-between">
        <p className="font-semibold flex items-center gap-2"><StickyNote size={16} className="text-[#E5B13A]" /> I miei appunti</p>
        <span className="flex items-center gap-1 text-[0.65rem] uppercase tracking-[0.15em] text-[#6F6A62]"><Lock size={10} /> solo tu</span>
      </div>
      <p className="text-xs text-[#9A948A] -mt-1">Ogni appunto resta con la sua data: rileggi tutta la storia del cliente. Lui non li vede.</p>
      <div className="flex gap-2 items-start">
        <textarea className={`${inputCls} min-h-[64px] text-sm leading-relaxed`} value={v} onChange={(e) => setV(e.target.value.slice(0, 2000))} placeholder="Es. Sentita oggi: lavora su turni, fa fatica col sonno. Le ho proposto Partenza leggera." data-testid="appunto-input" />
        <Btn className="px-3 py-3 shrink-0" onClick={add} disabled={busy || !v.trim()} data-testid="appunto-add"><Plus size={16} /></Btn>
      </div>
      {appunti.length > 0 && (
        <div className="space-y-2" data-testid="appunti-list">
          {appunti.map((a) => (
            <div key={a.id} className="rounded-2xl bg-[#0E0E10] border border-[#232328] px-3 py-2.5" data-testid={`appunto-${a.id}`}>
              <div className="flex items-center justify-between gap-2">
                <span className="text-[0.65rem] uppercase tracking-[0.15em] text-[#9A948A]">{fmt(a.at)}{a.da ? ` · ${a.da}` : ""}</span>
                <button onClick={() => remove(a)} className="text-[#6F6A62] hover:text-[#ff9a9e]" data-testid={`appunto-del-${a.id}`}><Trash2 size={12} /></button>
              </div>
              <p className="text-sm mt-1 whitespace-pre-line text-[#F4EFE6]/90">{a.testo}</p>
            </div>
          ))}
        </div>
      )}
      <div className={`rounded-2xl border px-3 py-2.5 space-y-2 ${scaduto ? "border-[#E5484D]/50 bg-[#E5484D]/10" : "border-[#232328] bg-[#0E0E10]"}`}>
        <span className="flex items-center gap-2 text-sm text-[#9A948A]"><BellRing size={14} className={scaduto ? "text-[#ff9a9e]" : "text-[#E5B13A]"} /> Risentire il</span>
        <span className="flex items-center gap-2 flex-wrap">
          <input type="date" lang="it" className={`${inputCls} w-auto py-1.5 text-sm`} value={ric} onChange={(e) => setRic(e.target.value)} data-testid="richiamo-input" />
          {ric && <button onClick={() => setRic("")} className="text-xs text-[#6F6A62] hover:text-white" data-testid="richiamo-clear">togli</button>}
          {ricDirty && <Btn className="px-3 py-1.5 text-xs" onClick={saveRic} disabled={busy} data-testid="richiamo-save">Salva</Btn>}
        </span>
      </div>
    </Card>
  );
}
